import { Link, useLocation } from 'react-router-dom'

const sectors = [
  {
    slug: 'adaptation-planning',
    title: 'Adaptation Planning',
    description: 'Guide communities through changing climate risk.',
  },
  {
    slug: 'land-use-planning',
    title: 'Land Use Planning and Development',
    description: "Design tomorrow's growth for tomorrow's risk.",
  },
  {
    slug: 'asset-infrastructure-planning',
    title: 'Asset and Infrastructure Planning',
    description: 'Invest in the right assets, in the right places, at the right time.',
  },
  {
    slug: 'emergency-planning',
    title: 'Emergency Planning and Business Continuity',
    description: 'The benefit of hindsight, beforehand.',
  },
  /*   {
    slug: 'compliance-financial-reporting',
    title: 'Compliance and Financial Reporting',
    description: 'Meet your disclosure obligations and strengthen your financial position.',
  },
  {
    slug: 'research-consultancy',
    title: 'Research and Consultancy',
    description: 'Make your work go further and be at the cutting edge.',
  }, */
]

const OtherSectors = () => {
  const location = useLocation()
  const urlParts = location.pathname.split('/').filter(Boolean)
  const slug = urlParts[urlParts.length - 1]

  return (
    <section className="bg-neutral-charcoal/15 py-24 sm:py-16">
      <div className="space-y-8 mx-auto max-w-5xl px-6 lg:px-8">
        <h1 className="text-4xl font-light text-brand-blue">
          See how Resilience Explorer®
          <br className="hidden md:block" /> enables action in other ways
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-lg leading-relaxed text-text-secondary lg:text-xl">
          {sectors
            .filter((sector) => sector.slug !== slug)
            .map((sector) => (
              <Link
                to={`/solutions/${sector.slug}`}
                key={sector.title}
                className="flex flex-col rounded-lg bg-white p-6 pb-4 gap-6 justify-between h-full cursor-pointer hover:shadow-lg transition-shadow no-underline"
              >
                <div className="flex flex-col gap-3">
                  <h2 className="text-left text-base font-bold text-brand-blue leading-tight">
                    {sector.title}
                  </h2>
                  <p className="text-sm text-brand-navy font-semibold tracking-tight leading-snug">
                    {sector.description}
                  </p>
                </div>
                <span className="text-brand-blue font-semibold text-sm self-end">Learn More →</span>
              </Link>
            ))}
        </div>
      </div>
    </section>
  )
}

export default OtherSectors
